import get from 'lodash/get';
import * as authorActions from '../../action_creators/author/author_action_creators';
import AuthorModel from '../../../models/author/author';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchAuthorAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(authorActions.authorLoading());
    return AuthorModel.fetch(params, store)
      .then(function handleAuthorData(AuthorData) {
        dispatch(authorActions.authorLoaded(AuthorData.data, store));
      })
      .catch(function handleAuthorError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(status, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in all author actions, message: ${err.message}`
          );
        }
        dispatch(authorActions.authorLoadError(err, store));
      });
  };
}
